import React, { useId } from "react";
import CustomFormField from "../CustomFormField/CustomFormField";
import TextEditor from "../../Screen/DataEntryPanel/CreateQuestion/textEditor";
import "../CustomTheme/customTheme.css";
import "./CustomRichTextEditor.css";

/**
 * CustomRichTextEditor — the project's CKEditor (TextEditor) inside the
 * standard field frame, so it gets the same label, red "*", hint,
 * red error message and border colours as every other Custom* field.
 *
 * Props:
 *  - value (HTML string), onChange(html) | setInputText(html)
 *  - maxWords   word limit (blocks typing past it, shows a snackbar)
 *  - label | title, isRequired, hint, error, colClass, id, className
 */
const CustomRichTextEditor = ({
  label,
  title,
  id,
  isRequired,
  hint,
  error,
  colClass,
  value,
  onChange,
  setInputText,
  maxWords,
  className,
}) => {
  const autoId = useId();
  const fieldId = id || `cre-${autoId}`;

  const handleChange = (html) => {
    onChange?.(html);
    setInputText?.(html);
  };

  return (
    <CustomFormField
      label={label ?? title}
      isRequired={isRequired}
      htmlFor={fieldId}
      hint={hint}
      error={error}
      colClass={colClass}
    >
      <div
        id={fieldId}
        className={`cre-wrap${error ? " cre-error" : ""}${className ? ` ${className}` : ""}`}
        aria-invalid={Boolean(error)}
      >
        <TextEditor
          value={value || ""}
          setInputText={handleChange}
          maxLength={maxWords}
          isSetWordCount={Boolean(maxWords)}
        />
      </div>
    </CustomFormField>
  );
};

export default CustomRichTextEditor;
